import { createFileRoute } from '@tanstack/react-router'
import {
  redirectPartnerToWorkspace,
  requireActiveSubscription,
} from '@/lib/middleware'
import { AuthenticatedLayout } from '@/components/layout/authenticated-layout'

export const Route = createFileRoute('/_authenticated/_organization')({
  beforeLoad: async ({ location }) => {
    const sessionData = await requireActiveSubscription(location.pathname)
    // Phase 3a: a compliance_partner org has no dashboard/roster/participants —
    // bounce it to its Providers home before any provider-shaped page loads.
    await redirectPartnerToWorkspace(location.pathname)
    return sessionData
  },
  component: AuthenticatedLayout,
})
